import { IconProps } from '../Icons.type'

export function ArrowDownIcon(props: IconProps) {
  return (
    <svg
      width="8"
      height="9"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M4.00307 8.50061C4.12688 8.50121 4.25089 8.45053 4.33995 8.3486L7.44663 4.79304C7.60814 4.6082 7.58922 4.32743 7.40438 4.16593C7.21954 4.00442 6.93877 4.02334 6.77726 4.20818L4.44528 6.8771L4.44528 0.945056C4.44528 0.699596 4.24629 0.500612 4.00083 0.500612C3.75537 0.500612 3.55639 0.699596 3.55639 0.945056L3.55639 6.86951L1.224 4.20771C1.06223 4.02309 0.781433 4.00457 0.596819 4.16634C0.412207 4.32811 0.393686 4.6089 0.555452 4.79352L3.63303 8.30575C3.71299 8.42336 3.84789 8.50061 4.00084 8.50061L4.00307 8.50061Z"
        fill="currentColor"
      />
    </svg>
  )
}
